import React, { useState, useEffect } from "react";
import {
    Box,
    Card,
    CardContent,
    CardHeader,
    Checkbox,
    Chip,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    Grid,
    IconButton,
    LinearProgress,
    Paper,
    Skeleton,
    Snackbar,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Tooltip,
    Typography,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import MoveToInboxOutlinedIcon from "@mui/icons-material/MoveToInboxOutlined";
import SearchIcon from "@mui/icons-material/Search";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import Page from "src/components/Page";
import Alert from "src/components/Alert";
import { makeStyles, ThemeProvider } from "@material-ui/core/styles";
import { createTheme } from "@material-ui/core/styles";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import trLocale from "date-fns/locale/tr";
import axios from "src/utils/axios";
import moment from "moment";
import { Button } from "@material-ui/core";

const materialTheme = createTheme({
    palette: {
        primary: {
            contrastText: "#FF9800",
            dark: "#424242",
            main: "#424242",
            light: "#424242",
        },
    },
});

const localeMap = { tr: trLocale };

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" style={{ color: "#FF9800" }} />;

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(3),
        marginTop: theme.spacing(2),
    },
    backdrop: {
        zIndex: 9999,
        color: "#fff",
    },
}));

const getLojistikChipColor = (status) => {
    switch (String(status)) {
        case "1":
            return "warning";
        case "2":
            return "info";
        case "3":
            return "success";
        default:
            return "default";
    }
};

const getLojistikLabel = (status, options) => {
    const found = (options || []).find((o) => o.value === String(status));
    return found ? found.label : status || "-";
};

const headCellSx = {
    fontWeight: 700,
    fontSize: "0.78rem",
    textTransform: "uppercase",
    letterSpacing: "0.4px",
    color: "#475569",
    whiteSpace: "nowrap",
    bgcolor: "#f1f5f9",
    textAlign: "center",
};

const PanelServicePickups = () => {
    const classes = useStyles();

    const [startDate, setStartDate] = useState(new Date().toString());
    const [endDate, setEndDate] = useState(new Date().toString());

    const [servisOptions, setServisOptions] = useState([]);
    const [selectedServis, setSelectedServis] = useState([]);
    const [lojistikOptions, setLojistikOptions] = useState([]);
    const [selectedLojistik, setSelectedLojistik] = useState([]);
    const [tableData, setTableData] = useState([]);

    const [loading, setLoading] = useState(false);
    const [savingLojistik, setSavingLojistik] = useState(false);
    const [uyari, setUyari] = useState(false);
    const [uyariTip, setUyariTip] = useState("default");
    const [responseMessage, setresponseMessage] = useState("success_message");

    const [editingRow, setEditingRow] = useState(null);
    const [editValue, setEditValue] = useState("");
    const [logisticStatusPopUpOpen, setLogisticStatusPopupOpen] = useState(false);

    const filteredData = tableData;

    useEffect(() => {
        axios
            .get("GetLogisticServices")
            .then((response) => {
                const data = Array.isArray(response.data)
                    ? response.data
                    : JSON.parse(response.data || "[]");

                const opts = data.map((item) => ({
                    value: String(item.BIRIM_KODU),
                    label: item.SERVIS,
                }));

                setServisOptions(opts);
            })
            .catch(() => setServisOptions([]));

        axios
            .get("GetLogisticStatus")
            .then((response) => {
                const data = Array.isArray(response.data)
                    ? response.data
                    : JSON.parse(response.data || "[]");

                const opts = data.map((item) => ({
                    value: String(item.DURUM),
                    label: item.ACIKLAMA,
                }));

                setLojistikOptions(opts);
            })
            .catch(() => setLojistikOptions([]));
    }, []);

    const handleLojistikEdit = (row) => {
        setEditingRow(row);
        setEditValue(String(row.LOJISTIK_DURUM || ""));
        setLogisticStatusPopupOpen(true);
    };

    const handleLojistikSave = () => {
        const selectedOption = lojistikOptions.find(
            (o) => o.value === String(editValue)
        );

        const payload = {
            ServicePaper: Number(editingRow.FIS_NO),
            LogisticStatus: Number(editValue),
            LogisticStatusType: 2,
        };

        setSavingLojistik(true);

        axios.post("/SetUpdateServicePaperLogisticStatus", payload)
            .then((response) => {
                const result = response.data;

                if (result?.ErrorCode === "0") {
                    setTableData((prev) =>
                        prev.map((r) =>
                            r.FIS_NO === editingRow.FIS_NO
                                ? {
                                    ...r,
                                    LOJISTIK_DURUM: String(editValue),
                                    LOJISTIK_DURUM_ACIKLAMA: selectedOption?.label || "",
                                }
                                : r
                        )
                    );

                    setLogisticStatusPopupOpen(false);

                    setresponseMessage("İşlem başarı ile gerçekleştirildi.");
                    setUyariTip("success");
                    setUyari(true);
                } else {
                    setresponseMessage(result?.ErrorDescription || "İşlem başarısız. Lütfen tekrar deneyiniz!...");
                    setUyariTip("error");
                    setUyari(true);
                }
            })
            .catch(() => {
                setresponseMessage("Bilinmeyen bir hata oluştu. Lütfen tekrar deneyiniz!...");
                setUyariTip("error");
                setUyari(true);
            })
            .finally(() => {
                setSavingLojistik(false);
            });
    };

    const handleLojistikCancel = () => {
        if (savingLojistik) return;
        setLogisticStatusPopupOpen(false);
    };

    const handleDialogExited = () => {
        setEditValue("");
        setEditingRow(null);
    };

    const handleFilter = () => {
        if (!startDate || !endDate) {
            setresponseMessage("Lütfen başlangıç ve bitiş tarihlerini giriniz.");
            setUyariTip("error");
            setUyari(true);
            return;
        }

        if (selectedServis.length === 0) {
            setresponseMessage("Lütfen en az bir servis seçiniz.");
            setUyariTip("error");
            setUyari(true);
            return;
        }

        if (selectedLojistik.length === 0) {
            setresponseMessage("Lütfen en az bir lojistik durumu seçiniz.");
            setUyariTip("error");
            setUyari(true);
            return;
        }

        setLoading(true);

        const birimKodu = selectedServis.map((s) => s.value).join(",");
        const lojistikDurumu = selectedLojistik.map((l) => l.value).join(",");

        axios.get("GetServicePickupDeliveryServices", {
            params: {
                BaslangicTarihi: moment(startDate).format("MM-DD-YYYY"),
                BitisTarihi: moment(endDate).format("MM-DD-YYYY"),
                TeslimAlinacakBirimKodu: birimKodu,
                LojistikDurumu: lojistikDurumu,
            },
        })
            .then((response) => {
                const data = response.data;

                if (Array.isArray(data)) {
                    setTableData(data);
                } else {
                    try {
                        const parsed = JSON.parse(data || "[]");
                        setTableData(Array.isArray(parsed) ? parsed : []);
                    } catch {
                        setTableData([]);
                    }
                }
            })
            .catch(() => {
                setTableData([]);
                setresponseMessage("Kayıtlar getirilirken hata oluştu.");
                setUyariTip("error");
                setUyari(true);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const uyariKapat = (event, reason) => {
        if (reason === "clickaway") return;
        setUyari(false);
    };

    return (
        <Page className={classes.root} title="Arçelik Panel Onarım Servisinden Teslim Alınacaklar">
            <Snackbar
                open={uyari}
                autoHideDuration={10000}
                onClose={uyariKapat}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <Alert
                    onClose={uyariKapat}
                    variant={uyariTip}
                    message={responseMessage}
                />
            </Snackbar>

            <Card elevation={2} sx={{ borderRadius: 3 }}>
                <CardHeader
                    avatar={
                        <MoveToInboxOutlinedIcon
                            sx={{ color: "primary.main", fontSize: 28 }}
                        />
                    }
                    title={
                        <Typography variant="h6" fontWeight={700}>
                            Arçelik Panel Onarım Servisinden Teslim Alınacaklar
                        </Typography>
                    }
                    sx={{
                        borderBottom: "1px solid",
                        borderColor: "divider",
                        pb: 1.5,
                    }}
                />

                <CardContent>
                    <Paper
                        variant="outlined"
                        sx={{ p: 2, mb: 3, borderRadius: 2, bgcolor: "#fafafa" }}
                    >
                        <Grid container spacing={2} alignItems="flex-end">
                            <Grid item xs={12} md={6} lg={2}>
                                <ThemeProvider theme={materialTheme}>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap["tr"]}>
                                        <KeyboardDatePicker
                                            fullWidth
                                            size="small"
                                            color="primary"
                                            inputVariant="outlined"
                                            label="Çağrı Başlangıç Tarihi"
                                            invalidDateMessage="Hatalı Tarih Formatı"
                                            format="dd.MM.yyyy"
                                            value={startDate}
                                            onChange={(date) => setStartDate(date)}
                                            KeyboardButtonProps={{ "aria-label": "change date" }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </ThemeProvider>
                            </Grid>

                            <Grid item xs={12} md={6} lg={2}>
                                <ThemeProvider theme={materialTheme}>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap["tr"]}>
                                        <KeyboardDatePicker
                                            fullWidth
                                            size="small"
                                            color="primary"
                                            inputVariant="outlined"
                                            label="Çağrı Bitiş Tarihi"
                                            invalidDateMessage="Hatalı Tarih Formatı"
                                            format="dd.MM.yyyy"
                                            value={endDate}
                                            onChange={(date) => setEndDate(date)}
                                            KeyboardButtonProps={{ "aria-label": "change date" }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </ThemeProvider>
                            </Grid>

                            <Grid item xs={12} md={6} lg={3}>
                                <Autocomplete
                                    multiple
                                    size="small"
                                    id="servis-multi-select"
                                    fullWidth
                                    limitTags={1}
                                    disableCloseOnSelect
                                    value={selectedServis}
                                    options={servisOptions}
                                    getOptionLabel={(option) => option.label || ""}
                                    isOptionEqualToValue={(option, value) =>
                                        option.value === value.value
                                    }
                                    onChange={(event, newValue) => setSelectedServis(newValue)}
                                    renderOption={(props, option, { selected }) => (
                                        <li {...props}>
                                            <Checkbox
                                                icon={icon}
                                                checkedIcon={checkedIcon}
                                                style={{ marginRight: 8 }}
                                                checked={selected}
                                            />
                                            {option.label}
                                        </li>
                                    )}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Teslim Alınacak Servis Kodu - Adı"
                                            variant="outlined"
                                        />
                                    )}
                                    sx={{
                                        "& .MuiAutocomplete-endAdornment": {
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                        },
                                    }}
                                />
                            </Grid>

                            <Grid item xs={12} md={6} lg={3}>
                                <Autocomplete
                                    multiple
                                    size="small"
                                    id="lojistik-multi-select"
                                    fullWidth
                                    limitTags={1}
                                    disableCloseOnSelect
                                    value={selectedLojistik}
                                    options={lojistikOptions}
                                    getOptionLabel={(option) => option.label || ""}
                                    isOptionEqualToValue={(option, value) =>
                                        option.value === value.value
                                    }
                                    onChange={(event, newValue) => setSelectedLojistik(newValue)}
                                    renderOption={(props, option, { selected }) => (
                                        <li {...props}>
                                            <Checkbox
                                                icon={icon}
                                                checkedIcon={checkedIcon}
                                                style={{ marginRight: 8 }}
                                                checked={selected}
                                            />
                                            {option.label}
                                        </li>
                                    )}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Lojistik Durumu"
                                            variant="outlined"
                                        />
                                    )}
                                    sx={{
                                        "& .MuiAutocomplete-endAdornment": {
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                        },
                                    }}
                                />
                            </Grid>

                            <Grid item xs={12} md={6} lg={2}>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    fullWidth
                                    startIcon={<SearchIcon />}
                                    onClick={handleFilter}
                                >
                                    Sorgula
                                </Button>
                            </Grid>
                        </Grid>
                    </Paper>

                    <TableContainer
                        component={Paper}
                        variant="outlined"
                        sx={{ borderRadius: 2 }}
                    >
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={headCellSx}>No</TableCell>
                                    <TableCell sx={headCellSx}>Fiş Numarası</TableCell>
                                    <TableCell sx={headCellSx}>Çağrı Tarihi</TableCell>
                                    <TableCell sx={headCellSx}>Teslim Alınacak Servis Kodu - Adı</TableCell>
                                    <TableCell sx={headCellSx}>Model Kodu - Adı</TableCell>
                                    <TableCell sx={headCellSx}>Fiş Durumu</TableCell>
                                    <TableCell sx={headCellSx}>Lojistik Durumu</TableCell>
                                    <TableCell sx={headCellSx}>Teslim Edilecek Servis Kodu - Adı</TableCell>
                                    <TableCell sx={{ ...headCellSx, textAlign: "center" }}>
                                        İşlem
                                    </TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {loading ? (
                                    Array.from(new Array(5)).map((_, index) => (
                                        <TableRow key={`skeleton-${index}`}>
                                            <TableCell><Skeleton variant="text" /></TableCell>
                                            <TableCell><Skeleton variant="text" /></TableCell>
                                            <TableCell><Skeleton variant="text" /></TableCell>
                                            <TableCell><Skeleton variant="text" /></TableCell>
                                            <TableCell><Skeleton variant="text" /></TableCell>
                                            <TableCell><Skeleton variant="rounded" height={24} /></TableCell>
                                            <TableCell><Skeleton variant="rounded" height={24} /></TableCell>
                                            <TableCell><Skeleton variant="text" /></TableCell>
                                            <TableCell align="center"><Skeleton variant="circular" width={30} height={30} sx={{ margin: '0 auto' }} /></TableCell>
                                        </TableRow>
                                    ))
                                ) : filteredData.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={9} align="center" sx={{ py: 5 }}>
                                            Kayıt bulunamadı.
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    filteredData.map((row, index) => (
                                        <TableRow
                                            key={index}
                                            hover
                                            align="center"
                                            sx={{
                                                "&:last-child td": { border: 0 },
                                                bgcolor: index % 2 === 0 ? "transparent" : "#fafafa",
                                            }}
                                        >
                                            <TableCell align="center" sx={{ width: 40 }}>
                                                {index + 1}
                                            </TableCell>

                                            <TableCell align="center">
                                                <Typography fontWeight={600} sx={{ whiteSpace: "nowrap" }}>
                                                    {row.FIS_NO}
                                                </Typography>
                                            </TableCell>

                                            <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                                                {row.CAGRI_TARIHI
                                                    ? new Date(row.CAGRI_TARIHI).toLocaleDateString("tr-TR")
                                                    : "-"}
                                            </TableCell>

                                            <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                                                23075 - ÇERMİK
                                            </TableCell>

                                            <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                                                {row.KUL_MODEL_KODU} - {row.MODEL_ACIKLAMA}
                                            </TableCell>

                                            <TableCell align="center">
                                                <Chip
                                                    label={row.FIS_DURUM_ACIKLAMA || row.FIS_DURUM}
                                                    color="primary"
                                                    size="small"
                                                    variant="outlined"
                                                />
                                            </TableCell>

                                            <TableCell align="center">
                                                <Chip
                                                    label={
                                                        row.LOJISTIK_DURUM_ACIKLAMA ||
                                                        getLojistikLabel(row.LOJISTIK_DURUM, lojistikOptions)
                                                    }
                                                    color={getLojistikChipColor(row.LOJISTIK_DURUM)}
                                                    size="small"
                                                />
                                            </TableCell>

                                            <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                                                {row.TESLIM_EDILECEK_KUL_BIRIM_KODU} - {row.TESLIM_EDILECEK_BIRIM_ACIKLAMA}
                                            </TableCell>

                                            <TableCell align="center">
                                                <Tooltip title="Lojistik Durumunu Güncelle">
                                                    <IconButton
                                                        size="small"
                                                        color="warning"
                                                        onClick={() => handleLojistikEdit(row)}
                                                    >
                                                        <EditOutlinedIcon fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <Dialog
                        open={logisticStatusPopUpOpen}
                        maxWidth="sm"
                        fullWidth
                        disableEscapeKeyDown={savingLojistik}
                        TransitionProps={{ onExited: handleDialogExited }}
                        PaperProps={{
                            sx: {
                                borderRadius: 3,
                                overflow: "hidden",
                            },
                        }}
                    >
                        {savingLojistik && <LinearProgress />}

                        <Box
                            sx={{
                                px: 3,
                                py: 2.2,
                                borderBottom: "1px solid #dbe3ea",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                bgcolor: "#f8fafc",
                            }}
                        >
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                                <Box
                                    sx={{
                                        width: 42,
                                        height: 42,
                                        borderRadius: 2,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        bgcolor: "#fff7ed",
                                        color: "#ea580c",
                                        border: "1px solid #fed7aa",
                                    }}
                                >
                                    <MoveToInboxOutlinedIcon />
                                </Box>

                                <Box>
                                    <Typography
                                        variant="subtitle1"
                                        fontWeight={700}
                                        sx={{ color: "#334155", lineHeight: 1.2 }}
                                    >
                                        Lojistik Durumu Güncelle
                                    </Typography>
                                    <Typography
                                        variant="caption"
                                        sx={{ color: "#64748b", mt: 0.3, display: "block" }}
                                    >
                                        Fiş No: <strong>{editingRow?.FIS_NO}</strong>
                                    </Typography>
                                </Box>
                            </Box>

                            <IconButton
                                size="small"
                                onClick={handleLojistikCancel}
                                disabled={savingLojistik}
                                sx={{
                                    color: "#64748b",
                                    "&:hover": {
                                        bgcolor: "#e2e8f0",
                                    },
                                }}
                            >
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        </Box>

                        <DialogContent
                            sx={{
                                px: 3,
                                py: 3,
                                bgcolor: "#ffffff",
                                opacity: savingLojistik ? 0.7 : 1,
                                transition: "opacity 0.2s ease",
                            }}
                        >
                            <Box
                                sx={{
                                    display: "grid",
                                    gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
                                    gap: 1.5,
                                    mb: 2,
                                }}
                            >
                                <Box
                                    sx={{
                                        p: 2,
                                        border: "1px solid #dbe3ea",
                                        borderRadius: 2,
                                        bgcolor: "#f8fafc",
                                        minHeight: 84,
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                    }}
                                >
                                    <Typography
                                        variant="caption"
                                        fontWeight={700}
                                        sx={{
                                            color: "#64748b",
                                            display: "block",
                                            letterSpacing: "0.4px",
                                            mb: 0.8,
                                        }}
                                    >
                                        TESLİM ALINACAK SERVİS
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        fontWeight={600}
                                        sx={{
                                            color: "#475569",
                                            lineHeight: 1.45,
                                        }}
                                    >
                                        23075 - ÇERMİK
                                    </Typography>
                                </Box>

                                <Box
                                    sx={{
                                        p: 2,
                                        border: "1px solid #dbe3ea",
                                        borderRadius: 2,
                                        bgcolor: "#f8fafc",
                                        minHeight: 84,
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                    }}
                                >
                                    <Typography
                                        variant="caption"
                                        fontWeight={700}
                                        sx={{
                                            color: "#64748b",
                                            display: "block",
                                            letterSpacing: "0.4px",
                                            mb: 0.8,
                                        }}
                                    >
                                        MODEL
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        fontWeight={600}
                                        sx={{
                                            color: "#475569",
                                            lineHeight: 1.45,
                                        }}
                                    >
                                        {`${editingRow?.KUL_MODEL_KODU} - ${editingRow?.MODEL_ACIKLAMA}`}
                                    </Typography>
                                </Box>
                            </Box>

                            <Box
                                sx={{
                                    border: "1px solid #dbe3ea",
                                    borderRadius: 2,
                                    p: 2,
                                    mb: 2,
                                    bgcolor: "#ffffff",
                                }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        gap: 1.5,
                                        flexWrap: "wrap",
                                    }}
                                >
                                    <Box>
                                        <Typography
                                            variant="body2"
                                            fontWeight={700}
                                            sx={{
                                                display: "block",
                                                color: "#64748b",
                                                letterSpacing: "0.4px",
                                            }}
                                        >
                                            MEVCUT LOJİSTİK DURUMU
                                        </Typography>
                                    </Box>

                                    <Chip
                                        label={editingRow?.LOJISTIK_DURUM_ACIKLAMA || "-"}
                                        color={getLojistikChipColor(editingRow?.LOJISTIK_DURUM)}
                                        size="medium"
                                        sx={{
                                            fontWeight: 700,
                                            borderRadius: "999px",
                                            px: 0.8,
                                            height: 32,
                                        }}
                                    />
                                </Box>
                            </Box>

                            <Box
                                sx={{
                                    border: "1px solid #dbe3ea",
                                    borderRadius: 2,
                                    p: 2,
                                    bgcolor: "#f8fafc",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 2,
                                }}
                            >
                                <Typography
                                    variant="caption"
                                    fontWeight={700}
                                    sx={{
                                        display: "block",
                                        color: "#475569",
                                        letterSpacing: "0.4px",
                                    }}
                                >
                                    YENİ LOJİSTİK DURUMU
                                </Typography>

                                <Autocomplete
                                    fullWidth
                                    size="small"
                                    options={lojistikOptions.filter((o) => o.label?.toLowerCase() !== "tümü")}
                                    getOptionLabel={(option) => option.label || ""}
                                    isOptionEqualToValue={(option, value) => option.value === value.value}
                                    value={lojistikOptions.find((o) => o.value === editValue) || null}
                                    onChange={(_, newValue) => setEditValue(newValue ? newValue.value : "")}
                                    disabled={savingLojistik}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder="Durum seçiniz..."
                                            variant="outlined"
                                            sx={{
                                                "& .MuiOutlinedInput-root": {
                                                    bgcolor: "#ffffff",
                                                    borderRadius: 2,
                                                    minHeight: 42,
                                                },
                                                "& .MuiOutlinedInput-notchedOutline": {
                                                    borderColor: "#cbd5e1",
                                                },
                                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                                    borderColor: "#94a3b8",
                                                },
                                                "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                    borderColor: "#64748b",
                                                },
                                            }}
                                        />
                                    )}
                                    sx={{
                                        "& .MuiAutocomplete-endAdornment": {
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                        },
                                    }}
                                />
                            </Box>
                        </DialogContent>

                        <DialogActions
                            sx={{
                                px: 3,
                                py: 2,
                                borderTop: "1px solid #e2e8f0",
                                bgcolor: "#f8fafc",
                                gap: 1,
                            }}
                        >
                            <Button
                                variant="contained"
                                color="secondary"
                                fullWidth
                                startIcon={
                                    savingLojistik ? (
                                        <CircularProgress size={18} color="inherit" />
                                    ) : (
                                        <CheckIcon />
                                    )
                                }
                                onClick={handleLojistikSave}
                                disabled={!editValue || savingLojistik}
                                sx={{
                                    fontWeight: 700,
                                    borderRadius: 2,
                                    boxShadow: "none",
                                }}
                            >
                                {savingLojistik ? "Kaydediliyor..." : "Kaydet"}
                            </Button>

                            <Button
                                variant="outlined"
                                fullWidth
                                startIcon={<CloseIcon />}
                                onClick={handleLojistikCancel}
                                disabled={savingLojistik}
                                sx={{
                                    borderColor: "#cbd5e1",
                                    color: "#334155",
                                    fontWeight: 700,
                                    borderRadius: 2,
                                    boxShadow: "none",
                                    "&:hover": {
                                        borderColor: "#94a3b8",
                                        bgcolor: "#f1f5f9",
                                    },
                                }}
                            >
                                Vazgeç
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Box sx={{ mt: 1.5 }}>
                        <Typography variant="caption">
                            Toplam{" "}
                            <Box component="span" fontWeight={700}>
                                {filteredData.length}
                            </Box>{" "}
                            kayıt listelenmektedir.
                        </Typography>
                    </Box>
                </CardContent>
            </Card>
        </Page>
    );
};

export default PanelServicePickups;